import {session} from 'wix-storage';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

let SpanishWebsiteURL = "https://celia39.wixsite.com/website";

$w.onReady(function () {
	// if(!session.getItem("userLang")){
	// 	checkLanguage();
	// }else if(session.getItem("userLang") === "es"){
	// 	showPopup();
	// }
})

function checkLanguage(){
	let browserLocale = wixWindow.browserLocale
	if(browserLocale.includes("es")){
		showPopup();
	}else{
		saveLanguage("en")
	}
}

function showPopup(){
	$w("#box2").expand();
}

function saveLanguage(lang){
	session.setItem("userLang", lang);
}

export function redirect(event) {
	$w("#box2").collapse();
	wixLocation.to(SpanishWebsiteURL);
}

export function stay(event) {
	$w("#box2").collapse();
	saveLanguage("en");
}